import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MobileCarousel = ({ children, testid }) => {
  const ref = useRef(null);
  const [active, setActive] = useState(0);
  const count = children.length;

  const cardStep = () => {
    const el = ref.current;
    if (!el || !el.firstChild) return 0;
    return el.firstChild.offsetWidth + 20;
  };

  const onScroll = () => {
    const el = ref.current;
    if (!el) return;
    setActive(Math.min(count - 1, Math.max(0, Math.round(el.scrollLeft / cardStep()))));
  };

  const goTo = (i) => {
    ref.current?.scrollTo({ left: i * cardStep(), behavior: "smooth" });
  };

  return (
    <div className="sm:hidden" data-testid={testid}>
      <div
        ref={ref}
        onScroll={onScroll}
        className="-mx-5 flex snap-x snap-mandatory items-start gap-5 overflow-x-auto px-5 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {children.map((child, i) => (
          <div key={i} className="w-[86%] shrink-0 snap-center">
            {child}
          </div>
        ))}
      </div>
      <div className="mt-5 flex items-center justify-center gap-3">
        <button
          data-testid={`${testid}-prev`}
          onClick={() => goTo(Math.max(0, active - 1))}
          aria-label="Previous"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E5E5E5] bg-white text-[#666666] transition-colors hover:border-[#C62828] hover:text-[#C62828]"
        >
          <ChevronLeft size={17} />
        </button>
        <div className="flex gap-2">
          {children.map((_, i) => (
            <button
              key={i}
              data-testid={`${testid}-dot-${i}`}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
              className={`h-2 rounded-full transition-all duration-300 ${
                active === i ? "w-6 bg-[#C62828]" : "w-2 bg-[#D9D9D9]"
              }`}
            />
          ))}
        </div>
        <button
          data-testid={`${testid}-next`}
          onClick={() => goTo(Math.min(count - 1, active + 1))}
          aria-label="Next"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E5E5E5] bg-white text-[#666666] transition-colors hover:border-[#C62828] hover:text-[#C62828]"
        >
          <ChevronRight size={17} />
        </button>
      </div>
    </div>
  );
};

export default MobileCarousel;
